// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-m_fu","advertDetailHeaderPrice__value":"c-m_fv","advertDetailHeaderPrice__label":"c-m_fw"};